import styled from 'styled-components';

import { TYPOGRAPHY } from '@ui-component-library/components/_deprecated/Typography';

import COLORS from '@ui-component-library/styles/colors';
import { TABS_RESET } from '@ui-component-library/styles/components.reset';
import { SPACING } from '@ui-component-library/styles/spacing';

export const S = {
  Container: styled.div`
    ${TABS_RESET}
    width: 100%;
  `,

  TabList: styled.div`
    display: flex;
    flex-direction: row;
    overflow-x: auto;

    // Hide native scrollbar across browsers
    scrollbar-width: none; // Firefox
    -ms-overflow-style: none; // IE and Edge
    &::-webkit-scrollbar {
      display: none; // Chrome, Safari, Opera
    }
  `,

  Tab: styled.button<{ $isActive?: boolean; $isScrollable?: boolean }>`
    ${TYPOGRAPHY.labelMediumMedium};
    padding: ${SPACING.size8} ${SPACING.size16};
    cursor: pointer;
    border: none;
    background-color: transparent;
    white-space: nowrap;
    font-weight: ${(props) => (props.$isActive && props.$isScrollable ? 'bold' : 'normal')};
    color: ${(props) => (props.$isActive ? COLORS['charcoal-500'] : COLORS['pebble-500'])};
    border-bottom: 3px solid
      ${(props) =>
        props.$isActive && !props.$isScrollable ? COLORS['charcoal-500'] : 'transparent'};
  `,

  ScrollTrack: styled.div`
    position: relative;
    width: 100%;
    height: 2px;
    background-color: ${COLORS['stone-300']};
    margin-top: ${SPACING.size4};
    border-radius: 2px;
  `,

  ScrollHandle: styled.div`
    position: absolute;
    top: 0;
    height: 100%;
    background-color: ${COLORS['charcoal-500']};
    border-radius: 2px;
  `
};
